import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function DeleteIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 10.94 12.79"
      style={{ width: `16px`, height: `16px`, color: RoutalPalette.secondary40, ...props.style }}
    >
      <g>
        <rect x="3.61" y="4.53" width="1.12" height="5.47" rx=".12" ry=".12" />
        <rect x="6.22" y="4.53" width="1.12" height="5.47" rx=".12" ry=".12" />
        <path d="M10.69,1.92H.25c-.07,0-.12.06-.12.12v.87c0,.07.06.12.12.12h.75v8.58c0,.55.45,1,1,1h6.96c.55,0,1-.45,1-1V3.04h.75c.07,0,.12-.06.12-.12v-.87c0-.07-.06-.12-.12-.12ZM8.83,3.04v8.46H2.12s0-8.46,0-8.46h6.71Z" />
        <rect x="3.61" y=".18" width="3.73" height="1.12" rx=".12" ry=".12" />
      </g>
    </SvgIcon>
  );
}
